var AuthorizationViewModule = (function (_app, _estimateShippmentView, _globalSettings, _eventHandler, _BaseView) {
    var hiddenClass = 'hidden-block';
    var errorFieldClass = 'errorField';

    var _logger = _app && _app.events && _app.events.embeddedLogin || {};

    var _mode = {
        signup: 1,
        signin: 2,
        forgotPassword: 3
    };

    var _changeModeEvent = 'ChangeAuthMode';

    var _currentMode = null;

    var consentBlock = new RegistrationConsentBlock('', 'join-consent-text');
    var recaptchaReady = recaptcha.init('recaptcha');

    var changeMode = function (mode) {
        if (_currentMode != mode) {
            _currentMode = mode;
            _eventHandler.trigger(_changeModeEvent, _currentMode);
        }
    }

    function showMessage(title, message) {
        if (!kos || !kos.dialog || !kos.dialog.popup) {
            alert(message);
        } else {
            if (window.messageDialog) {
                window.messageDialog.destroy();
            }
            window.messageDialog = kos.dialog.popup({
                title: title,
                message: message
            });
        }
    }

    function registered() {
        var data = arguments[1] || arguments[0];
        var regInfo = data.Value.Data;

        _app.cookie.set('a', 'l=1&r=');

        if (regInfo.Registered) {
            _app.cookie.setFirstLogin();
            if (window.Pixel && window.Pixel.registrationTrack)
                window.Pixel.registrationTrack.setRegistred();
        }

        window.cookie && cookie.remove('invitedBy');

        _logger.signup_success && _logger.signup_success();
        reload();
    }

    function loginSuccess () {
        _logger.signin_success && _logger.signin_success();
        reload();
    }

    function reload() {
        window.__isAuthorized__ = true;
        app.checkout.update_checkout(true).fail(function() {
            location.reload();
        });
    }

    function signup(data) {
        if (data === null) return;
        _logger.signupClick && _logger.signupClick();

        var def = new $.Deferred();
        
        var consentValues = consentBlock.validate('</br>');
        consentValues.message && showMessage('', consentValues.message);

        if (consentValues.tcAccepted && consentValues.emailsAccepted != null) {
            var invitedBy = window.cookie && cookie.get('invitedBy') || null;
            if (!data.forename) {
                data.forename = null;
            }
            if (!data.surname) {
                data.surname = null;
            }
            data.parameters = consentValues;
            data.invitedBy = invitedBy || queryParams.get("invitedBy") || null;
            data.referredBy = queryParams.get("referredBy") || null;
            data.voucherID = queryParams.get("voucherID") || kos.guidEmpty;

            recaptchaReady
                .done(function () {
                    recaptcha.execute().done(function (token) {
                        data.captchaResponse = token;
                        _logger.signup_method && _logger.signup_method();
                        api.signup(data, { wait: true, hideErrors: true, disableErrorEmitter: true })
                            .done(function(data) {
                                registered(data);
                                def.resolve();
                            })
                            .fail(def.reject);
                    });
                })
                .fail(function () {
                    _logger.signup_customer_method && _logger.signup_customer_method();
                    api.signupCustomet(data, { wait: true, hideErrors: true, disableErrorEmitter: true })
                        .done(function (data) {
                            registered(data);
                            def.resolve();
                        })
                        .fail(def.reject);
                });
        }
        return def.promise();
    }

    function signin(data) {
        if (data === null) return;
        _logger.signinClick && _logger.signinClick();

        var def = new $.Deferred();

        recaptchaReady
            .done(function () {
                recaptcha.execute().done(function (token) {
                    data.captchaResponse = token;
                    _logger.signin_method && _logger.signin_method();
                    data.userName = data.email;
                    api.signin(data, { wait: true, hideErrors: true, disableErrorEmitter: true })
                        .done(function () {
                            loginSuccess();
                            def.resolve();
                        })
                        .fail(def.reject);
                });
            })
            .fail(function () {
                _logger.signin_customer_method && _logger.signin_customer_method();
                api.signinCustomet(data, { wait: true, hideErrors: true, disableErrorEmitter: true })
                    .done(function () {
                        loginSuccess();
                        def.resolve();
                    })
                    .fail(def.reject);
            });
        return def.promise();
    }

    function sendPassword(data) {
        if (data === null) return;
        _logger.forgotPasswordClick && _logger.forgotPasswordClick();
        return api.forgotPassword(data, { wait: true, hideErrors: true, disableErrorEmitter: true });
    }

    var AuthorizationView = _BaseView.extend({
        el: '@embidedAuthorization',
        events: {
            'click @chooseSignup': '_chooseSignup',
            'click @chooseSignin': '_chooseSignin'
        },
        initialize: function () {
            _.bindAll(this, '_toggle', '_switchFormMode');

            if (app.settings.get('UseEmbeddedLoginForm')) {
                //_eventHandler.on('switchFormMode', this._switchFormMode);
                this.onChangeDeliverySectionMode(this._switchFormMode);
                this._switchFormMode();

                this.$el.append($.tmpl('authorization_base'));

                _eventHandler.on(_changeModeEvent, this._toggle);
            } else {
                this.$el.remove();
            }
        },
        _switchFormMode: function (e, mode) {
            mode = mode || this.getDeliverySectionMode();
            this.$el.toggleClass(hiddenClass, mode !== this.deliverySectionMode.embeddedLogin);
        },
        _toggle: function (e, mode) {
            this.$('@chooseSignup').toggleClass('delivery-chooser__active', mode === _mode.signup);
            this.$('@chooseSignin').toggleClass('delivery-chooser__active', mode === _mode.signin);
        },
        _chooseSignup: function () {
            changeMode(_mode.signup);
        },
        _chooseSignin: function () {
            changeMode(_mode.signin);
        }
    });

    var FormView = _BaseView.extend({
        events: {
            'click @btnSignin': '_signin',
            'click @btnSignup': '_signup',
            'click @btnSendPassword': '_sendPassword',
            'click @forgotPassword': '_chooseForgotPassword',
            'focus input': '_focus'
        },

        descriptionWarningClass: 'embided-auth-form-description__warning',

        initialize: function () {
            _.bindAll(this, '_toggle', '_validate', '_blink');
            this._render();
            this.onPayButtonClick(this._blink);
            this.onPayButtonClick(this._validate);
            _eventHandler.on(_changeModeEvent, this._toggle);

        },
        _render: function() {
            this.displayFirstLastName = !_globalSettings.SBEO;
            this.$el.html($.tmpl('authorization_form'));

            this.$description = this.$('@authorizationDescription');
            this.$forename = this.$('@forename');
            this.$surname = this.$('@surname');
            this.$email = this.$('@email');
            this.$password = this.$('@password');

            this.$consentBlock = this.$('@authorization-consent-block');
            consentBlock.appendTo(this.$consentBlock);

            this.$signinBtn = this.$('@_Signin');
            this.$signupBtn = this.$('@_Signup');
            this.$facebookBtn = this.$('@_Facebook');
            this.$visaBtn = this.$('@v-button-form');
            this.$passwordBtn = this.$('@_ForgotPassword');
            this.$backToLoginBtn = this.$('@_BackToLogin');
            this.$sendPassword = this.$('@_SendPassword');

            setTimeout(_.bind(function () {
                this.$('#_password').attr('type', 'password');
            }, this), 500);
        },
        _chooseForgotPassword: function (e) {
            e.preventDefault();
            changeMode(_mode.forgotPassword);
        },
        _toggle: function (e, mode) {

            this._setDescription(false);

            this.$forename.toggleClass(hiddenClass, !this.displayFirstLastName || mode !== _mode.signup);
            this.$surname.toggleClass(hiddenClass, !this.displayFirstLastName || mode !== _mode.signup);
            this.$password.toggleClass(hiddenClass, mode === _mode.forgotPassword);

            this.$consentBlock.toggleClass(hiddenClass, mode !== _mode.signup);

            this.$signinBtn.toggleClass(hiddenClass, mode !== _mode.signin);
            this.$signupBtn.toggleClass(hiddenClass, mode !== _mode.signup);
            this.$facebookBtn.toggleClass(hiddenClass, mode === _mode.forgotPassword);
            this.$visaBtn.toggleClass(hiddenClass, mode !== _mode.signup);
            this.$passwordBtn.toggleClass(hiddenClass, mode !== _mode.signin);
            this.$backToLoginBtn.toggleClass(hiddenClass, true || mode !== _mode.forgotPassword);
            this.$sendPassword.toggleClass(hiddenClass, mode !== _mode.forgotPassword);

            this.$('input').each(function(i, el) {
                $(el).removeClass(errorFieldClass);
            });
        },
        _setDescription: function (isWarning) {
            var descriptionText = _currentMode === _mode.forgotPassword
                ? GetPageTemplate("_ForgotPasswordInvitation")
                : 'Authorize to chose delivery address and continue payment';
            this.$description.html(descriptionText);
            this.$description.toggleClass(this.descriptionWarningClass, isWarning);
        },
        _setWarning: function (warningText) {
            this.$description.html(warningText);
            this.$description.addClass(this.descriptionWarningClass);
        },
        _setMessage: function (messageText) {
            this.$description.html(messageText);
            this.$description.removeClass(this.descriptionWarningClass);
        },
        _focus: function(e) {
            $(e.target).removeClass(errorFieldClass);
            this._setDescription(false);
        },
        _signup: function () {
            var data = this._getFormdata();
            signup(data)
                .done(_.bind(function () {
                    this.setDeliverySectionMode();
                }, this))
                .fail(_.bind(function (result) {
                    if (!result.Result && result.Message) {
                        this._setWarning(result.Message);
                    }
                }, this));
        },
        _signin: function () {
            var data = this._getFormdata();
            signin(data)
                .done(_.bind(function () {
                    this.setDeliverySectionMode();
                }, this))
                .fail(_.bind(function (result) {
                    if (!result.Result && result.Message) {
                        this._setWarning(result.Message);
                    }
                }, this));
        },
        _sendPassword: function () {
            var data = this._getFormdata();
            sendPassword(data)
                .done(_.bind(function (result) {
                    if (result.Result) {
                        this._setMessage(GetPageTemplate("_PasswordRecovery"));
                    }
                }, this))
                .fail(_.bind(function (result) {
                    if (!result.Result && result.Message) {
                        this._setWarning(result.Message);
                    }
                }, this));
        },
        _getFormdata: function () {
            var result = this._validate();
            if (!result.isValid) {
                _logger.fields_not_filled && _logger.fields_not_filled();
                 return null;
            }
            return result.data;
        },
        _blink: function () {
            if (DisplayEmbeddedLoginForm()) {
                _logger.pay_button_click && _logger.pay_button_click();
                this._setDescription(true);
            }
        },
        _validate: function() {
            var isValid = true;
            var data = {};
            this.$('input').each(function(i, el) {
                var parent = $(el).parent();
                if (!parent.hasClass(hiddenClass)) {
                    var type = $(el).attr('validate');
                    var name = $(el).attr('name');
                    var value = $(el).val();
                    var trimVal = (value || '').replace(/^\s*|\s*$/g, '');
                    if ((type === '*' || type === '@') && trimVal === '') {
                        $(el).addClass(errorFieldClass);
                        isValid = false;
                    } else if (type === '@' && _currentMode !== _mode.signin &&
                        !/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(
                            trimVal)) {
                        $(el).addClass(errorFieldClass);
                        isValid = false;
                    }
                    data[name.replace(/^_/, '')] = value;
                }
            });

            return {
                isValid: isValid,
                data: data
            };
        }
    });

    var authorizationView = new AuthorizationView();
    var formView = new FormView();
    var _estimateShippment = new _estimateShippmentView({ model: _app.models.summary });


    authorizationView.$el.prepend(_estimateShippment.$el);
    authorizationView.$el.append(formView.$el);
    ThirdPartyAuthorization && ThirdPartyAuthorization(registered);

    if ((_app.cookie.get('a') || '').indexOf('l=1') >= 0) {
        changeMode(_mode.signin);
    } else {
        changeMode(_mode.signup);
    }
});